const DETAIL_EXCHANGE_LABELS: Record<string, string> = {
  NAS: 'Nasdaq',
};

export function formatDetailExchangeLabel(exchange: string): string {
  return DETAIL_EXCHANGE_LABELS[exchange] ?? exchange;
}
